import { render, staticRenderFns } from "./ind_editor.vue?vue&type=template&id=5b604a81"
import script from "./ind_editor.vue?vue&type=script&lang=js"
export * from "./ind_editor.vue?vue&type=script&lang=js"
import style0 from "./ind_editor.vue?vue&type=style&index=0&id=5b604a81&prod&lang=less"
import style1 from "./ind_editor.vue?vue&type=style&index=1&id=5b604a81&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports